import React                      from 'react'

import { TEXT }                   from '../00_assets'
import { kde_api_client_address_t
       , kde_api_client_address_fields_t
       }                          from '../02_api'



export const ADDRESS_LABEL =
  { street1 : TEXT.CLIENT_ADDR_STREET1
  , street2 : TEXT.CLIENT_ADDR_STREET2
  , city    : TEXT.CLIENT_ADDR_CITY
  , province: TEXT.CLIENT_ADDR_PROVINCE
  , zipCode : TEXT.CLIENT_ADDR_ZIP_CODE
  , country : TEXT.CLIENT_ADDR_COUNTRY
  } ;


export const render_address = ( row: { address: kde_api_client_address_t | null } ) =>
{
  const obj = row.address || {} ;

  return <span>
        { [ show_address( obj, 'street1'  )
          , show_address( obj, 'street2'  )
          , show_composite_address( obj, 'zipCode', 'city' ) 
          , show_address( obj, 'province' ) 
          , show_address( obj, 'country'  ) 
        ]
        .filter( (data: { key: string, text: string }) => data.text !== '' )
        .map( address => <div key={address.key}>{ address.text }</div> ) }
    </span>
}

const show_address = ( row: any, what: kde_api_client_address_fields_t ) => 
        ({ key: what, text: row[ what ] || '' })

const show_composite_address = ( row: any, a: kde_api_client_address_fields_t, b: kde_api_client_address_fields_t) => 
  ({ key: 'compose', text: [row[ a ], row[ b ]].filter( item => !!item ).join( ' ' ) }) ;
